(function() {
	'use strict';

	angular.module('resultUploadedCollectionApp').controller(
			'ResultUploadedController', ResultUploadedController);

	ResultUploadedController.$inject = [ '$scope', '$state', '$log',
			'NgTableParams', 'authExpiredInterceptor', '$base64', '$window',
			'GLOBAL_URL', '$filter', 'ResultUploadedService', '$stateParams' ];

	function ResultUploadedController($scope, $state, $log, NgTableParams,
			authExpiredInterceptor, $base64, $window, GLOBAL_URL, $filter,
			ResultUploadedService, $stateParams) {

		// init all data
		var resultCtrl = this;
		var self = $scope;
		$scope.loading = false;
		var parent = $scope.$parent;

		resultCtrl.init = function() {
			resultCtrl.formatExport = 'pdf';
			resultCtrl.fromSource = '1';
		};
		
		resultCtrl.fromDate = new Date();
		resultCtrl.toDate = new Date();

		resultCtrl.datePickerOpenStatus = {};
		resultCtrl.datePickerOpenStatus.fromDate = false;
		resultCtrl.datePickerOpenStatus.toDate = false;
		resultCtrl.openCalendar = function(date) {
			$scope.clearMessage();
			resultCtrl.datePickerOpenStatus[date] = true;
			resultCtrl.validateDates();
		};

		resultCtrl.validateDates = function() {
			$scope.clearMessage();

			var currentDate = new Date();
			var toDate = moment(resultCtrl.toDate, "DD/MM/YYYY");
			var fromDate = moment(resultCtrl.fromDate, "DD/MM/YYYY");
			if (currentDate < fromDate) {
				resultCtrl.checkDate = true;
				$scope
						.addAlert(
								'Vui lòng chọn Từ Ngày bằng hoặc nhỏ hơn ngày hiện tại.',
								'error');
			} else if (toDate.diff(fromDate) < 0) {
				resultCtrl.checkDate = true;
				$scope.addAlert(
						'Vui lòng chọn Đến Ngày lớn hơn hoặc bằng Từ ngày.',
						'error');
			} else {
				resultCtrl.checkDate = false;
			}
		};

		resultCtrl.table = new NgTableParams({
			page : 1,
			count : 20
		}, {
			total : 0,
			counts : [],
			defaultSort : 'desc',
			getData : function(params) {
				var param = {};
				param['page'] = params.page();
				param['size'] = params.count();
				param['uri'] = 'searchResultUploaded';
				param['fromSource'] = resultCtrl.fromSource;
				param['fromDate'] = resultCtrl.fromDate;
				param['toDate'] = resultCtrl.toDate;
				param['status'] = resultCtrl.colectionStatus;

				$scope.loading = true;
				return ResultUploadedService.get(param).$promise.then(function(
						result) {
					$scope.loading = false;
					$(window).scrollTop(0);
					params.total(result.totalElements);
					return result.content;
				}, function(err) {
					$scope.loading = false;
				});
			}
		});

		resultCtrl.search = function() {
			if (!resultCtrl.checkDate) {
				resultCtrl.table.page(1);
				resultCtrl.table.count(20);
				resultCtrl.table.total(0);
				resultCtrl.table.reload();
			}
		};

		resultCtrl.printReport = function() {
			resultCtrl.report = {
				'formatExport' : resultCtrl.formatExport,
				'fromDate' : resultCtrl.fromDate,
				'toDate' : resultCtrl.toDate,
				'transactionType' : resultCtrl.fromSource,
				'status' : resultCtrl.colectionStatus
			};
			$scope.loading = true;
			ResultUploadedService.downloadReport(resultCtrl.report, function() {
				$scope.loading = false;
			}, function() {
				$scope.loading = false;
			});
		}
	}
})();
